import React, { useEffect, useState } from "react";
import "../../css_files/Customer/CustomerInfoPopup.css";
import axiosInstance from "../../api";
import CloseForm from "../Master/CloseForm";
import { useNavigate } from "react-router-dom";

function CustomerInfoPopup({
  id,
  setShowCustomerPopup,
  setShowTicketInfo,
  setTicketInfoData,
  setQuotationId,
  setTicketId,
  setEnquiryInfoData,
  setshowenquiryInfo,
  setEnquiryId,
}) {
  const [customerData, setCustomerData] = useState();
  const [EnquiryData, setEnquiryData] = useState([]);
  const [TicketData, setTicketData] = useState([]);
  const [quotationData, setQuotationData] = useState([]);
  const nav = useNavigate();
  const [show, setShow] = useState({
    showEnquiry: false,
    showTicket: false,
    showQuotation: false,
  });

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Customer/GetCustomerByIdOrName?id=${id}`
      )
      .then((res) => {
        setCustomerData(res.data.data[0]);
        axiosInstance
          .get(
            `${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry/GetEnquiriesByCustomerId/${res.data.data[0]?.id}`
          )
          .then((enquiries) => {
            setEnquiryData(enquiries.data);
            enquiries.data.forEach((enquiry) => {
              axiosInstance
                .get(
                  `${process.env.REACT_APP_API_URL}/api/v1/Ticket/GetTicketByEnquiryId/${enquiry.seriesID}`
                )
                .then((ticket) => {
                  setTicketData((prev) => [...prev, ticket.data]);
                  axiosInstance
                    .get(
                      `${process.env.REACT_APP_API_URL}/api/v1/Quotation/GetQuotationByTicketId/${ticket.data.seriesId}`
                    )
                    .then((quotation) => {
                      setQuotationData((prev) => [...prev, quotation.data]);
                    })
                    .catch(console.log);
                })
                .catch(console.log);
            });
          })
          .catch(console.log);
      })
      .catch(console.log);
  }, [id]);
  return (
    <section className="customer-info-popup">
      <div>
        <h1>Customer Data</h1>
        <aside>
          <p>
            <strong>Customer/Company Name: </strong>
            {customerData?.orgName}
          </p>
          <p>
            <strong>Customer Code: </strong>
            {customerData?.code}
          </p>
          <p>
            <strong>Description: </strong>
            {customerData?.description}
          </p>
          <blockquote>
            <p>
              <strong>Enquiries: </strong>
              {EnquiryData.length}
            </p>
            <i
              className={`fa-solid ${
                show.showEnquiry ? "fa-angle-up" : "fa-angle-down"
              }`}
              onClick={() => {
                setShow({ ...show, showEnquiry: !show.showEnquiry });
              }}
            ></i>
          </blockquote>
          {show.showEnquiry && (
            <aside>
              {EnquiryData.map((enquiry) => (
                <blockquote>
                  <p>
                    <strong>Series Id: </strong>
                    {enquiry.seriesID}
                  </p>
                  <i
                    className="fa-solid fa-info-circle"
                    onClick={() => {
                      setshowenquiryInfo(true);
                      setEnquiryInfoData(enquiry);
                    }}
                    title="Click Here To See More Details"
                  ></i>
                </blockquote>
              ))}
            </aside>
          )}
          <blockquote>
            <p>
              <strong>Tickets: </strong>
              {TicketData.length}
            </p>
            <i
              className={`fa-solid ${
                show.showTicket ? "fa-angle-up" : "fa-angle-down"
              }`}
              onClick={() => {
                setShow({ ...show, showTicket: !show.showTicket });
              }}
            ></i>
          </blockquote>
          {show.showTicket && (
            <aside>
              {TicketData.map((ticket) => (
                <blockquote>
                  <p>
                    <strong>Series Id: </strong>
                    {ticket.seriesId}
                  </p>
                  <i
                    className="fa-solid fa-info-circle"
                    onClick={() => {
                      setShowTicketInfo(true);
                      setTicketInfoData(ticket);
                    }}
                    title="Click Here To See More Details"
                  ></i>
                </blockquote>
              ))}
            </aside>
          )}
          <blockquote>
            <p>
              <strong>Quotations: </strong>
              {quotationData.length}
            </p>
            <i
              className={`fa-solid ${
                show.showQuotation ? "fa-angle-up" : "fa-angle-down"
              }`}
              onClick={() => {
                setShow({ ...show, showQuotation: !show.showQuotation });
              }}
            ></i>
          </blockquote>
          {show.showQuotation && (
            <aside>
              {quotationData.map((quotation) => (
                <blockquote>
                  <p>
                    <strong>Series Id: </strong>
                    {quotation.seriesId}
                  </p>
                  <i
                    className="fa-solid fa-info-circle"
                    onClick={() => {
                      setEnquiryId(quotation.ticket.enquirySeriesId);
                      setTicketId(quotation.ticketId);
                      setQuotationId(quotation.seriesId);
                      nav("/dashboard/checkin/steps/step3");
                    }}
                    title="Click Here To See More Details"
                  ></i>
                </blockquote>
              ))}
            </aside>
          )}
        </aside>
        <CloseForm close={setShowCustomerPopup} />
      </div>
    </section>
  );
}

export default CustomerInfoPopup;
